export function tabbedSlider() {
    const tabbedSliderWrap = $('.tabbed-slider-wrap');
    tabbedSliderWrap.each(function () {
        const tabbedSliderNav = $(this).find('.tabbed-slider-nav');
        const prevArrow = $(this).find('.prev-arrow');
        const nextArrow = $(this).find('.next-arrow');
        const tabbedSliderContent = $(this).find('.tabbed-slider-content');
        let adaptiveHeight  = !!$(this).parents().hasClass('has-solutions-listing');
        let sliderSettings = {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            prevArrow: prevArrow,
            nextArrow: nextArrow,
            asNavFor: tabbedSliderContent,
            focusOnSelect: true,
            mobileFirst: true,
            variableWidth: true,
            responsive: [
                {
                    breakpoint: 567,
                    settings: {
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 1023,
                    settings: {
                        slidesToShow: 4,
                        variableWidth: false
                    }
                },
                {
                    breakpoint: 1799,
                    settings: {
                        slidesToShow: 5,
                        variableWidth: false
                    }
                }
            ]
        }

        if ($(this).parents().hasClass('our-clients') || $(this).parents().hasClass('has-solutions-listing')) {
            sliderSettings = {
                slidesToShow: 2,
                slidesToScroll: 1,
                infinite: false,
                prevArrow: prevArrow,
                nextArrow: nextArrow,
                asNavFor: tabbedSliderContent,
                focusOnSelect: true,
                mobileFirst: true,
                responsive: [
                    {
                        breakpoint: 567,
                        settings: {
                            slidesToShow: 3
                        }
                    },
                    {
                        breakpoint: 1023,
                        settings: {
                            slidesToShow: 5,
                        }
                    },
                    {
                        breakpoint: 1799,
                        settings: {
                            slidesToShow: 6
                        }
                    }
                ]
            };
        }

        tabbedSliderContent.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            fade: true,
            speed: 0,
            asNavFor: tabbedSliderNav,
            infinite: false,
            adaptiveHeight: adaptiveHeight
        }).on('afterChange', function (event, slick, currentSlide, nextSlide) {
            let currentSlideDom = $(slick.$slides.get(currentSlide));
            currentSlideDom.find("[data-digits-counter]").each(function () {
                $(this).prop('Counter', 0).animate({
                    Counter: $(this).text()
                }, {
                    duration: 2000,
                    easing: 'swing',
                    step: function (now) {
                        $(this).text(Math.ceil(now));
                    }
                });
            });
        });
        tabbedSliderNav.slick(sliderSettings);

        if (prevArrow.hasClass("slick-hidden")) {
            tabbedSliderNav.addClass("arrows-hidden");
        }
    })
}


// WEBPACK FOOTER //
// ./assets/js/modules/tabbedSlider.js